module.exports = __webpack_public_path__ + "img/5-text.6b3c551a.png";